<div class="d-table">
    <div class="d-table-row" *ngFor="let inputName of dealTypeInputNames">
        <div class="d-table-cell">
            <button
                mat-button
                type="button"
                (click)="setDealTypeInput(inputName, true)"
                [class.selected]="dealTypeSelections[inputName] === true"
                [attr.aria-selected]="dealTypeSelections[inputName] === true"
            >
                {{ dealTypeLabels[inputName][0] }}
            </button>
        </div>
        <div class="d-table-cell deal-type-or">OR</div>
        <div class="d-table-cell">
            <button
                mat-button
                type="button"
                (click)="setDealTypeInput(inputName, false)"
                [class.selected]="dealTypeSelections[inputName] === false"
                [attr.aria-selected]="dealTypeSelections[inputName] === false"
            >
                {{ dealTypeLabels[inputName][1] }}
            </button>
        </div>
    </div>
</div>
